import { createRxDatabase } from 'rxdb/plugins/core';
import { getRxStorageDexie } from 'rxdb/plugins/storage-dexie';
import { wrappedValidateAjvStorage } from 'rxdb/plugins/validate-ajv';
import { replicateRxCollection } from 'rxdb/plugins/replication';
import { map } from 'rxjs/operators';

let dbPromise = null;
const createDB = async () => {
    try {
        const db = await createRxDatabase({
            name: 'rdo-db',
            storage: wrappedValidateAjvStorage({
                storage: getRxStorageDexie()
            }),
            ignoreDuplicate: true
        });

        const storeLogSchema = {
            version: 0,
            primaryKey: 'id',
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    maxLength: 100 // Required for primary key
                },
                partition: {
                    type: 'string',
                    maxLength: 100 // Optional but can help avoid regex issues
                },
                status: {
                    type: 'string',
                    maxLength: 50 // Example limit
                },
                done: {
                    type: 'boolean'
                },
                timestamp: {
                    type: 'number',
                }
            },
            required: ['id', 'status']
        };

        const miniappRequestSchema = {
            version: 0,
            primaryKey: 'id',
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    maxLength: 100
                },
                partition: {
                    type: 'string',
                    maxLength: 100
                },
                status: {
                    type: 'string',
                    maxLength: 50
                },
                key: {
                    type: 'string',
                    maxLength: 20
                },
                meta: {
                    type: 'string',
                    maxLength: 100
                },
                value: {
                    type: 'string',
                    maxLength: 100
                },
                done: {
                    type: 'boolean'
                },
                timestamp: {
                    type: 'integer'
                }
            },
            required: ['id', 'status', 'done', 'partition', 'key', 'meta', 'value']
        };

        await db.addCollections({
            storelog: {
                schema: storeLogSchema
            },
            miniapprequests: {
                schema: miniappRequestSchema
            }
        });

        return db;
    } catch (error) {
        console.error('Database creation failed:', error);
        if (error.message && error.message.includes('Database deleted by request')) {
            dbPromise = null;
            return createDB();
        }
        throw error;
    }
}
export const getDB = async () => {
    try {
        if (!dbPromise) {
            dbPromise = createDB();
        } else {
            // Check if existing database is closed/destroyed
            const db = await dbPromise;
            if (db.destroyed || db.closed) {
                console.log('Database is closed/destroyed, reopening...');
                dbPromise = null;
                dbPromise = createDB();
            }
        }
        return await dbPromise;
    } catch (error) {
        console.error('Failed to get database:', error);
        // Handle various database error scenarios
        if (error.message && (
            error.message.includes('Database deleted by request') ||
            error.message.includes('Need to reopen db') ||
            error.message.includes('database is closed')
        )) {
            console.log('Database needs to be reopened, resetting...');
            dbPromise = null;
            return getDB();
        }
        throw error;
    }
}

// Export function to reset database (useful when removing/destroying database)
export const resetDB = () => {
    dbPromise = null;
}

export const replicationStoreLog = async (db, partition, getClient) => {
    const subscription = await getClient.graphql({
        query: `
        subscription MySubscription($partition: String!) {
          onPushStoreLogs(partition: $partition) {
            checkpoint {
              id
              updatedAt
            }
            documents {
              timestamp
              status
              id
              done
              partition
              _deleted
            }
          }
        }
      `,
        variables: { partition: partition }
    });

    replicateRxCollection({
        collection: db.storelog,
        replicationIdentifier: 'my-http-replication',
        pull: {
            async handler(checkpointOrNull, batchSize) {
                const data = await getClient.graphql({
                    query: `query MyQuery {
                                  pullStoreLogs(limit: 10) {
                                    checkpoint {
                                      id
                                      updatedAt
                                    }
                                    documents {
                                      _deleted
                                      partition
                                      done
                                      id
                                      status
                                      timestamp
                                    }
                                  }
                                }`,
                    variables: {},
                });
                return data.data.pullStoreLogs;
            },
            stream$: subscription.pipe(
                map(data => {
                    console.log('stream store log-------- ', data);

                    return data.data.onPushStoreLogs;
                })
            )
        },
    });
}

export const replicationMiniappReq = async (db, partition, getClient) => {
    const subscription = getClient.graphql({
        query: `
          subscription MySubscription($partition: String!) {
            onPushMiniappRequests(partition: $partition) {
              checkpoint {
                id
                updatedAt
              }
              documents {
                _deleted
                done
                id
                key
                meta
                partition
                status
                timestamp
                value
              }
            }
          }
        `,
        variables: { partition: partition }
    });

    replicateRxCollection({
        collection: db.miniapprequests,
        replicationIdentifier: 'my-http-replication',
        pull: {
            async handler(checkpointOrNull, batchSize) {
                const data = await getClient.graphql({
                    query: `
                        query MyQuery {
                            pullMiniappRequests(limit: 10) {
                            checkpoint {
                                id
                                updatedAt
                            }
                            documents {
                                _deleted
                                done
                                id
                                key
                                meta
                                partition
                                status
                                timestamp
                                value
                            }
                            }
                        }
                        `,
                    variables: {},
                });
                return data.data.pullMiniappRequests;
            },
            stream$: subscription.pipe(
                map(data => {
                    console.log('stream miniapp reqq---', data.data.onPushMiniappRequests);

                    return data.data.onPushMiniappRequests;
                })
            )
        },
    });
};